import { handleActions } from 'redux-actions'
import { STORE_TABLE } from './type'
import { createInitialTableState, createReducerFunction, DESC } from '../../../table/state/reducer'


export const initialState = {
    storeList: [],
    fetching: false,
    error: null,
    ...createInitialTableState(STORE_TABLE, 'store_store', {
        'store_store.created': DESC,
    },{'limit':5000}),
}


export default handleActions({
    ...createReducerFunction(STORE_TABLE),

}, initialState)



// WEBPACK FOOTER //
// ./src/modules/store/state/search/reducer.js